var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndoSmallicon = function SvgUndoSmallicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3.732 4.732 2.247-2.247a.5.5 0 0 0 0-.707l-.425-.424a.5.5 0 0 0-.707 0L1.234 4.966a.8.8 0 0 0 0 1.132L4.847 9.71a.5.5 0 0 0 .707 0l.425-.425a.5.5 0 0 0 0-.707L3.732 6.332h6.052A3.217 3.217 0 0 1 13 9.55c0 1.77-1.459 3.217-3.242 3.217h-.526a.5.5 0 0 0-.5.5v.6a.5.5 0 0 0 .5.5h.526c2.654 0 4.842-2.15 4.842-4.818a4.817 4.817 0 0 0-4.817-4.816H3.732Z",
    clipRule: "evenodd"
  })));
};
export default SvgUndoSmallicon;